/* eslint-disable import/prefer-default-export */
import { inject } from 'vue';

import { FontStyleType } from '@constants/font-style';

type UseFontStyleType = { fontStyle: FontStyleType };
type UseFontStyleFunctionType = () => UseFontStyleType;

export const useFontStyle: UseFontStyleFunctionType = () => {
  const fontStyle = inject<FontStyleType>('$fontStyle');
  return { fontStyle } as UseFontStyleType;
};
